var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecycle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 161
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1598)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80.0312,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9187 22.4312C64.0745 22.4312 58.695 25.5588 55.7818 30.5987L45.6841 48.2028L63.1094 58.2648H63.1273C68.6681 48.114 73.8466 36.9433 79.1561 29.8173",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.296 49.0785L103.59 30.5987C100.677 25.5588 95.2978 22.4312 89.4536 22.4312H69.8657C79.052 22.4133 87.6485 42.2692 96.8526 59.1405L91.4374 62.2681L111.865 65.0383L119.675 45.9509L114.26 49.0785H114.296Z",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6714 121.609C35.5845 126.649 40.9819 129.758 46.8082 129.758H68.1654V110.153L68.1476 110.135C60.9451 110.313 40.8032 110.206 38.5871 110.135C36.9724 110.085 35.4478 109.991 34.0275 109.836",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9905 79.8949L56.3701 83.0046L49.7216 63.7563L28.1321 66.6874L33.5652 69.8329L22.9849 88.1339C20.0718 93.1739 20.0718 99.3934 22.9849 104.451L32.3499 121.019C27.7389 113.03 41.1787 95.944 50.9905 79.877V79.8949Z",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.971 80.7534L125.414 70.6914L135.637 88.3312C138.55 93.3711 138.55 99.5906 135.637 104.648L125.468 121.609C126.39 120.011 126.64 118.068 126.373 115.854C126.143 113.954 125.531 111.853 124.635 109.599C121.332 101.297 114.162 90.9135 107.971 80.7713V80.7534Z",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.619 104.648L125.45 121.608C122.537 126.648 117.139 129.758 111.313 129.758H90.3489V136.031L77.7312 119.714L90.3489 103.396V110.063H90.3311C97.0867 110.242 104.236 110.116 110.83 110.152C115.427 110.18 119.758 110.126 123.507 109.748",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecycle);
export default __webpack_public_path__ + "static/media/icon_recycle.c3c2c82a6b3f743e780c16390521f022.svg";
export { ForwardRef as ReactComponent };